import styled from 'styled-components';

export const StyledEmptyCard = styled.div`
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #f4f4f4;
  border-radius: 4px;
  background-color: #fbfbfb;
`;
